import React from 'react';
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import './Modal.scss';

const index = (props) => {
  const { open, onClose, handelConfirmationMessage, confirmationInfo } = props;
  return (
    <Modal open={open} onClose={onClose} size="tiny" >
      {confirmationInfo.action.type === 'error' ? <div className="header"> Error</div> :
        <div className="header">{confirmationInfo.action.type === 'alert' ? 'Alert' : confirmationInfo.action.type === "Success" ? "Success" : 'Confirmation'}</div>
      }
      <div className="content">
        <div className="col-md-12" >
          {confirmationInfo && confirmationInfo.action && confirmationInfo.action.confirmationMessage}
        </div>
      </div>
      <div className="actions">
        {
          confirmationInfo && confirmationInfo.action.type !== 'error' && confirmationInfo.action.type !== 'alert' && confirmationInfo.action.type != "Success" &&
          <><button
            type="button"
            className="btn btn-secondary"
            onClick={handelConfirmationMessage.bind(this, true, confirmationInfo)}>
            Ok
          </button>{' '}</>
        }
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handelConfirmationMessage.bind(this, false, confirmationInfo)}>
          Close
          </button>
      </div>
    </Modal>
  );
}

export default index;

// -------* Modal Confirmation propTypes set * ------
index.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handelConfirmationMessage: PropTypes.func.isRequired,
  confirmationInfo: PropTypes.object,
}